import React, { useState, useEffect, useMemo, useRef } from "react";
import {
    Table,
    Button,
    message,
    Popconfirm,
    Space,
    Tooltip,
    Drawer,
    Tag,
    Row,
    Col,
    Card,
    Badge,
    Empty,
    Input,
    Modal,
    Switch,
    Alert,
    Dropdown,
    Menu,
    Select,
    Typography,
    Tabs,
    Statistic,
    Divider,
    Progress,
    notification,
    Timeline,
    Descriptions,
    Avatar,
    DatePicker,
    Spin
} from "antd";
import { Form } from "antd";
import {
    KeyOutlined,
    EyeOutlined,
    DeleteOutlined,
    UserOutlined,
    TeamOutlined,
    CrownOutlined,
    ReloadOutlined,
    FilterOutlined,
    FireOutlined,
    RocketOutlined,
    PoweroffOutlined,
    ThunderboltOutlined,
    CheckOutlined,
    CloseOutlined,
    PauseOutlined,
    EllipsisOutlined,
    CheckCircleOutlined,
    StarFilled,
    BellFilled,
    CheckCircleFilled,
    CloseCircleFilled,
    ClockCircleOutlined,
    HistoryOutlined,
    InfoCircleOutlined,
    GlobalOutlined,
    CalendarOutlined,
    CloseOutlined as CloseIcon,
    DashboardOutlined,
    BarChartOutlined,
    LineChartOutlined,
    PieChartOutlined,
    DownloadOutlined,
    EditOutlined
} from "@ant-design/icons";

import RecycleBin from "./RecycleBin.jsx";
import API from "../../API/API";
import { useDomainGroups } from "../../Context/DomainGroupsContext";
import { agentGroupNames } from "../../Utils";
import "../../App.css";
import AddTeam from "./AddTeam.jsx";
import Config from "../../API/Config.js";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import io from "socket.io-client";
import { Storage } from "../../Utils.js";
import EditTeamDrawer from "./EditTeamDrawer.jsx";

const { Search } = Input;
const { Option } = Select;
const { Text, Title } = Typography;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;

// Styles
const styles = `
@keyframes gradientShift {
    0% { background-position: 0% 50%; }
    50% { background-position: 100% 50%; }
    100% { background-position: 0% 50%; }
}

@keyframes pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
}

@keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-10px); }
}

@keyframes notificationPulse {
    0% { transform: scale(1); }
    50% { transform: scale(1.2); }
    100% { transform: scale(1); }
}

@keyframes slideIn {
    from {
        opacity: 0;
        transform: translateX(20px);
    }
    to {
        opacity: 1;
        transform: translateX(0);
    }
}

.gradient-card {
    background: linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab);
    background-size: 400% 400%;
    animation: gradientShift 15s ease infinite;
    border-radius: 20px;
    padding: 24px;
    color: white;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;
}

.gradient-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.3);
}

.glass-card {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(20px);
    border-radius: 16px;
    border: 1px solid rgba(255, 255, 255, 0.2);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.performance-active {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.performance-inactive {
    background: linear-gradient(135deg, #606c88 0%, #3f4c6b 100%);
}

.floating-badge {
    animation: float 3s ease-in-out infinite;
}

.table-row-active {
    background: linear-gradient(90deg, rgba(240, 147, 251, 0.05) 0%, rgba(245, 87, 108, 0.05) 100%);
    transition: all 0.3s ease;
}

.table-row-active:hover {
    background: linear-gradient(90deg, rgba(240, 147, 251, 0.1) 0%, rgba(245, 87, 108, 0.1) 100%);
}

.table-row-online {
    background: linear-gradient(90deg, rgba(17, 153, 142, 0.05) 0%, rgba(56, 239, 125, 0.05) 100%);
    transition: all 0.3s ease;
}

.table-row-online:hover {
    background: linear-gradient(90deg, rgba(17, 153, 142, 0.1) 0%, rgba(56, 239, 125, 0.1) 100%);
}

.table-row-offline {
    background: linear-gradient(90deg, rgba(189, 195, 199, 0.05) 0%, rgba(149, 165, 166, 0.05) 100%);
    transition: all 0.3s ease;
}

.table-row-offline:hover {
    background: linear-gradient(90deg, rgba(189, 195, 199, 0.1) 0%, rgba(149, 165, 166, 0.1) 100%);
}

.notification-bell {
    animation: notificationPulse 0.5s ease-in-out;
}

.notification-item {
    transition: all 0.3s ease;
    animation: slideIn 0.3s ease;
}

.notification-item:hover {
    background: linear-gradient(135deg, #f5f7fa 0%, #e8eaf6 100%);
    transform: translateX(-5px);
}

.notification-time {
    font-size: 11px;
    color: #999;
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 4px;
}

.online-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #52c41a;
    animation: pulse 1.5s ease-in-out infinite;
}

.offline-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #f5222d;
}

.history-timeline .ant-timeline-item {
    padding-bottom: 20px;
}

.history-timeline .ant-timeline-item-content {
    margin-left: 24px;
}

.status-change-card {
    transition: all 0.3s ease;
    cursor: pointer;
    border-radius: 12px;
    overflow: hidden;
}

.status-change-card:hover {
    transform: translateY(-2px) scale(1.02);
    box-shadow: 0 12px 24px rgba(0,0,0,0.15);
}

.drawer-tabs .ant-tabs-nav {
    margin-bottom: 0;
    padding: 0 24px;
    background: linear-gradient(135deg, #f5f7fa 0%, #e8eaf6 100%);
    border-bottom: 2px solid #667eea;
}

.drawer-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 32px;
    color: #fff;
    text-align: center;
    position: relative;
    overflow: hidden;
}

.drawer-header::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 200%;
    height: 200%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
    animation: rotate 20s linear infinite;
}

@keyframes rotate {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}

.drawer-header.performance-active {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
}

.timeline-container {
    max-height: 500px;
    overflow-y: auto;
    padding-right: 8px;
}

.timeline-container::-webkit-scrollbar {
    width: 6px;
}

.timeline-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 10px;
}

.timeline-container::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 10px;
}

.timeline-container::-webkit-scrollbar-thumb:hover {
    background: #555;
}

.quick-filter-btn {
    transition: all 0.3s ease;
    border-radius: 20px;
    font-weight: 600;
}

.quick-filter-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.quick-filter-btn.active {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    border: none;
    box-shadow: 0 8px 20px rgba(102, 126, 234, 0.6);
}

.date-preset-tag {
    cursor: pointer;
    transition: all 0.3s ease;
    padding: 6px 16px;
    border-radius: 20px;
    font-weight: 600;
}

.date-preset-tag:hover {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(102, 126, 234, 0.4);
}

.stat-card {
    transition: all 0.3s ease;
    cursor: pointer;
    border-radius: 16px;
    overflow: hidden;
}

.stat-card:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 30px rgba(0,0,0,0.2);
}

.role-badge {
    padding: 4px 12px;
    border-radius: 20px;
    font-weight: 600;
    font-size: 12px;
    display: inline-block;
}

.role-badge.admin {
    background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
    color: white;
}

.role-badge.sales-agent {
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    color: white;
}

.role-badge.tier-1 {
    background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);
    color: white;
}

.role-badge.tier-2 {
    background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
    color: white;
}

.role-badge.tier-3 {
    background: linear-gradient(135deg, #f5576c 0%, #f093fb 100%);
    color: white;
}

.action-button {
    transition: all 0.3s ease;
    border-radius: 8px;
}

.action-button:hover {
    transform: scale(1.1);
}

.history-summary-card {
    background: linear-gradient(135deg, #f5f7fa 0%, #e8eaf6 100%);
    border-radius: 16px;
    padding: 20px;
    margin-bottom: 20px;
    border-left: 5px solid #667eea;
}

.loading-skeleton {
    animation: pulse 1.5s ease-in-out infinite;
}
`;

const Team = () => {
    // States
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 20, total: 0 });
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [drawerWidth, setDrawerWidth] = useState(500);
    const [currentUser, setCurrentUser] = useState(null);
    const [recycleBinVisible, setRecycleBinVisible] = useState(false);
    const [form] = Form.useForm();
    const navigate = useNavigate();
    const [loginAgent, setLoginAgent] = useState({});
    const [groupToggling, setGroupToggling] = useState({});
    const [currentToggleId, setCurrentToggleId] = useState(null);
    const searchDebounceRef = useRef(null);

    // States for status history
    const [activeDrawerTab, setActiveDrawerTab] = useState('details');
    const [userStatusHistory, setUserStatusHistory] = useState([]);
    const [historyLoading, setHistoryLoading] = useState(false);
    const [statusStats, setStatusStats] = useState(null);
    const [historyPage, setHistoryPage] = useState(1);
    const [historyTotal, setHistoryTotal] = useState(0);
  const [dateRange, setDateRange] = useState(() => {
    const now = dayjs();
    return [now.startOf('month'), now.endOf('month')];
  });
    const [selectedPreset, setSelectedPreset] = useState('today');

    // Socket states
    const [socket, setSocket] = useState(null);
    const [isSocketConnected, setIsSocketConnected] = useState(false);

    // Notification states
    const [notificationCount, setNotificationCount] = useState(0);
    const [notifications, setNotifications] = useState([]);

    // Tab and filter states
    const [activeTab, setActiveTab] = useState('all');
    const [performanceFilter, setPerformanceFilter] = useState('all');
    const [performanceToggling, setPerformanceToggling] = useState({});
    const [bulkPerformanceLoading, setBulkPerformanceLoading] = useState(false);
    const [statusFilter, setStatusFilter] = useState('all');

const [editDrawerVisible, setEditDrawerVisible] = useState(false);
const [editingUser, setEditingUser] = useState(null);

    // Check if current user is ADMIN
    const isAdmin = loginAgent?.role === "ADMIN";
    // Only admin@premiumusedautoparts.com gets this flag from the login / currentagent API.
    const canManageSuperAdmin = isAdmin && loginAgent?.canManageSuperAdmin === true;
    const [superAdminToggling, setSuperAdminToggling] = useState({});

    // One column per visible group, in the order an admin put them in. Nothing
    // about the lanes is hardcoded here any more.
    const { groups, visibleGroups, loading: groupsLoading } = useDomainGroups();

    // Helper function to get default date range based on preset
    const getDefaultDateRange = (preset) => {
        const today = dayjs();
        switch (preset) {
            case 'today':
                return [today.startOf('day'), today.endOf('day')];
            case 'yesterday':
                return [today.subtract(1, 'day').startOf('day'), today.subtract(1, 'day').endOf('day')];
            case 'thisWeek':
                return [today.startOf('week'), today.endOf('day')];
            case 'last7Days':
                return [today.subtract(7, 'day').startOf('day'), today.endOf('day')];
            case 'thisMonth':
                return [today.startOf('month'), today.endOf('day')];
            case 'last30Days':
                return [today.subtract(30, 'day').startOf('day'), today.endOf('day')];
            default:
                return [today.startOf('day'), today.endOf('day')];
        }
    };

    // Helper function to format time
    const formatNotificationTime = (timestamp) => {
        const date = new Date(timestamp);
        const now = new Date();
        const diffMs = now - date;
        const diffMins = Math.floor(diffMs / 60000);
        const diffHours = Math.floor(diffMs / 3600000);
        const diffDays = Math.floor(diffMs / 86400000);

        if (diffMins < 1) return 'Just now';
        if (diffMins < 60) return `${diffMins} min${diffMins > 1 ? 's' : ''} ago`;
        if (diffHours < 24) return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
        if (diffDays < 7) return `${diffDays} day${diffDays > 1 ? 's' : ''} ago`;

        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    // Format duration helper
    const formatDuration = (seconds) => {
        if (!seconds || seconds < 0) return '0s';

        const hours = Math.floor(seconds / 3600);
        const minutes = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        const parts = [];
        if (hours > 0) parts.push(`${hours}h`);
        if (minutes > 0) parts.push(`${minutes}m`);
        if (secs > 0 || parts.length === 0) parts.push(`${secs}s`);

        return parts.join(' ');
    };

    // Inject custom styles
    useEffect(() => {
        const styleSheet = document.createElement("style");
        styleSheet.textContent = styles;
        document.head.appendChild(styleSheet);
        return () => document.head.removeChild(styleSheet);
    }, []);

    const getAvatarGradient = (value = "") => {
        const gradients = [
            '#667eea',
            '#f093fb',
            '#4facfe',
            '#43e97b',
            '#fa709a',
            '#30cfd0',
            '#a8edea',
            '#ff9a56',
        ];
        let hash = 0;
        for (let i = 0; i < value.length; i++) {
            hash = value.charCodeAt(i) + ((hash << 5) - hash);
        }
        return gradients[Math.abs(hash) % gradients.length];
    };

    // Load loginAgent
    useEffect(() => {
        const UD = Storage.get("userData");
        if (!UD) {
            navigate("/login");
        } else {
            try {
                setLoginAgent(UD);
            } catch { setLoginAgent({}); }
        }
    }, [navigate]);

    // Initialize Socket.io
    useEffect(() => {
        const newSocket = io(Config.baseURL, {
            transports: ["websocket", "polling"],
            withCredentials: true,
        });

        newSocket.on('connect', () => {
            console.log('✅ Socket.io connected');
            setIsSocketConnected(true);
        });

        newSocket.on('disconnect', () => {
            console.log('❌ Socket.io disconnected');
            setIsSocketConnected(false);
        });

        newSocket.on('connect_error', (error) => {
            console.error('Socket.io connection error:', error);
            setIsSocketConnected(false);
        });

        setSocket(newSocket);

        return () => {
            if (newSocket) {
                newSocket.disconnect();
            }
        };
    }, []);

    // Real-time notifications (only for admins)
    useEffect(() => {
        if (!socket || !isAdmin) return;

        const handler = ({ userId, isActive, isPerformance, previousStatus, reason, timestamp, sessionDuration }) => {
            const user = data.find(u => u._id === userId);
            const timestampDate = timestamp ? new Date(timestamp) : new Date();

            const timeString = timestampDate.toLocaleTimeString('en-US', {
                hour: '2-digit',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            });

            setData(prev => prev.map(u => {
                if (u._id === userId) {
                    return {
                        ...u,
                        isActive: isActive !== undefined ? isActive : u.isActive,
                        isPerformance: isPerformance !== undefined ? isPerformance : u.isPerformance,
                    };
                }
                return u;
            }));

            setNotificationCount(prev => prev + 1);

            if (user) {
                const notificationItem = {
                    id: Date.now() + Math.random(),
                    userId,
                    userName: user.userName || user.email,
                    userEmail: user.email,
                    isActive,
                    isPerformance,
                    previousStatus,
                    reason,
                    sessionDuration,
                    timestamp: timestampDate,
                    timeString,
                    read: false,
                    type: isActive !== undefined ? 'status' : 'performance'
                };
                setNotifications(prev => [notificationItem, ...prev].slice(0, 50));
            }

            if (isActive !== undefined && user) {
                notification.open({
                    message: (
                        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                            <span>
                                {isActive ? (
                                    <><CheckCircleFilled style={{ color: '#52c41a', marginRight: 8 }} /> Agent Online</>
                                ) : (
                                    <><CloseCircleFilled style={{ color: '#f5222d', marginRight: 8 }} /> Agent Offline</>
                                )}
                            </span>
                            <span style={{ fontSize: 11, color: '#999' }}>
                                <ClockCircleOutlined style={{ marginRight: 4 }} />
                                {timeString}
                            </span>
                        </div>
                    ),
                    description: (
                        <div>
                            <div>
                                <strong>{user?.userName || 'Agent'}</strong> changed from <strong>{previousStatus ? 'Online' : 'Offline'}</strong> to <strong>{isActive ? 'ONLINE' : 'OFFLINE'}</strong>
                            </div>
                            {reason && (
                                <div style={{ marginTop: 4, fontSize: 12, color: '#666' }}>
                                    <InfoCircleOutlined style={{ marginRight: 4 }} />
                                    Reason: {reason}
                                </div>
                            )}
                            {sessionDuration && !isActive && (
                                <div style={{ marginTop: 4, fontSize: 12, color: '#52c41a' }}>
                                    <ClockCircleOutlined style={{ marginRight: 4 }} />
                                    Session duration: {formatDuration(sessionDuration)}
                                </div>
                            )}
                        </div>
                    ),
                    icon: isActive ?
                        <CheckCircleFilled style={{ color: '#52c41a' }} /> :
                        <CloseCircleFilled style={{ color: '#f5222d' }} />,
                    placement: 'topRight',
                    duration: 5,
                });

                setTimeout(() => {
                    setNotificationCount(prev => Math.max(0, prev - 1));
                }, 5000);
            }
        };

        socket.on("userStatusChanged", handler);
        socket.on("account-status-updated", handler);
        socket.on("agent-status-changed", handler);

        return () => {
            socket.off("userStatusChanged", handler);
            socket.off("account-status-updated", handler);
            socket.off("agent-status-changed", handler);
        };
    }, [socket, data, isAdmin]);

    // Drawer width responsive
    useEffect(() => {
        const onResize = () => setDrawerWidth(Math.min(window.innerWidth * 0.8, 600));
        window.addEventListener("resize", onResize);
        onResize();
        return () => window.removeEventListener("resize", onResize);
    }, []);

    // Handle edit user
const handleEditUser = (user) => {
    setEditingUser(user);
    setEditDrawerVisible(true);
};

// Handle update success
const handleUserUpdate = (updatedUser) => {
    // Update the user in the local data array
    setData(prevData => 
        prevData.map(u => 
            u._id === updatedUser._id ? { ...u, ...updatedUser } : u
        )
    );
    message.success('User updated successfully');
    
    // If the drawer is open with this user, update currentUser
    if (currentUser && currentUser._id === updatedUser._id) {
        setCurrentUser(updatedUser);
    }
};

    // Handle Make All Offline (admin only)
    const handleMakeAllOffline = async () => {
        if (!isAdmin) {
            message.error("Only admins can perform this action");
            return;
        }

        try {
            setLoading(true);
            message.loading("Processing... Setting users offline", 0);

            const usersToUpdate = data.filter(user =>
                user._id !== loginAgent.id && user.role !== "ADMIN"
            );

            if (usersToUpdate.length === 0) {
                message.info("No eligible users to set offline");
                return;
            }

            let successCount = 0;
            let failedCount = 0;

            for (const user of usersToUpdate) {
                try {
                    // Ensure isActive is a boolean
                    const res = await API.ToggleStatus(user._id, false);
                    if (res.success) {
                        successCount++;
                    } else {
                        failedCount++;
                    }
                } catch (err) {
                    console.warn(`Failed to update user ${user._id}:`, err);
                    failedCount++;
                }
            }

            await fetchData(pagination.current, pagination.pageSize, searchText);

            message.success(
                `Updated ${successCount} user${successCount !== 1 ? 's' : ''} successfully` +
                (failedCount > 0 ? ` (${failedCount} failed)` : "")
            );

        } catch (err) {
            console.error("Bulk offline failed:", err);
            message.error("Operation failed unexpectedly");
        } finally {
            setLoading(false);
            message.destroy();
        }
    };

    // Handle Performance Toggle (admin only)
    // Super admin on/off (owner account only; backend checks again).
    const handleSuperAdminToggle = async (record, nextValue) => {
        if (!canManageSuperAdmin) return;
        setSuperAdminToggling(prev => ({ ...prev, [record._id]: true }));
        try {
            const res = await API.setSuperAdmin(record._id, nextValue);
            if (res?.success) {
                setData(prev => prev.map(u =>
                    u._id === record._id ? { ...u, isSuperAdmin: nextValue } : u
                ));
                message.success(res.message || (nextValue ? 'Super admin turned on' : 'Super admin turned off'));
            } else {
                message.error(res?.message || 'Failed to change super admin');
            }
        } catch (err) {
            console.error('handleSuperAdminToggle error', err);
            message.error('Failed to change super admin');
        } finally {
            setSuperAdminToggling(prev => ({ ...prev, [record._id]: false }));
        }
    };

    const handlePerformanceToggle = async (userId, currentStatus) => {
        if (!isAdmin) {
            message.error("Only admins can toggle performance mode");
            return;
        }

        setPerformanceToggling(prev => ({ ...prev, [userId]: true }));

        try {
            const newStatus = !currentStatus;
            // Ensure isPerformance is a boolean
            const res = await API.UpdateUser(userId, { 
                isPerformance: newStatus === true // Explicit boolean
            });

            if (res.success) {
                setData(prev => prev.map(u =>
                    u._id === userId ? { ...u, isPerformance: newStatus } : u
                ));

                message.success({
                    content: newStatus ?
                        <span><FireOutlined /> Performance ACTIVE</span> :
                        <span><PauseOutlined /> Performance PAUSED</span>,
                    duration: 3,
                });

                if (socket && isSocketConnected) {
                    socket.emit("performanceStatusChanged", {
                        userId,
                        isPerformance: newStatus,
                        timestamp: new Date().toISOString()
                    });
                }
            }
        } catch (error) {
            console.error('Performance toggle error:', error);
            message.error("Failed to update performance mode");
        } finally {
            setPerformanceToggling(prev => ({ ...prev, [userId]: false }));
        }
    };

    /**
     * The one handler behind every group column. Which group a switch belongs to
     * is data, so there is nothing per-lane to keep in step here.
     */
    const handleGroupToggle = async (record, group, checked) => {
        const isEditable = isAdmin || record._id === loginAgent.id;

        if (!isEditable) {
            message.error("You do not have permission to update domain groups");
            return;
        }

        if (record.role !== "SALES-AGENT" || record.subRole !== group.tier) {
            message.error(`"${group.name}" is only available for ${group.tier} sales agents`);
            return;
        }

        const loadingKey = `${record._id}-${group._id}`;
        setGroupToggling(prev => ({ ...prev, [loadingKey]: true }));

        // Optimistic, so a slow request does not make the switch feel stuck.
        const applyMembership = (member) => {
            setData(prevData =>
                prevData.map(user => {
                    if (user._id !== record._id) return user;

                    const current = (user.domainGroups || []).map(String);
                    const next = member
                        ? Array.from(new Set([...current, String(group._id)]))
                        : current.filter(id => id !== String(group._id));

                    return { ...user, domainGroups: next };
                })
            );
        };

        applyMembership(checked);

        try {
            const response = await API.setDomainGroupMembership(group._id, record._id, checked);

            if (response.success) {
                if (currentUser && currentUser._id === record._id) {
                    setCurrentUser(prevUser => ({
                        ...prevUser,
                        domainGroups: response.data?.domainGroups || prevUser.domainGroups
                    }));
                }

                message.success(response.message || `${group.name} updated`);
            } else {
                applyMembership(!checked);
                message.error(response.message || `Failed to update ${group.name}`);
            }
        } catch (error) {
            applyMembership(!checked);
            console.error("Domain group toggle error:", error);
            message.error(`Failed to update ${group.name}`);
        } finally {
            setGroupToggling(prev => ({ ...prev, [loadingKey]: false }));
        }
    };

    // Initial load
    useEffect(() => {
        if (loginAgent?.role) {
            fetchData(1, pagination.pageSize, "");
        }
    }, [loginAgent.role]);

    // Fetch data
    const fetchData = async (page = pagination.current, pageSize = pagination.pageSize, search = searchText) => {
        setLoading(true);
        try {
            const response = await API.UserPagination({ page, limit: pageSize, search });
            if (response.success) {
                const { data: results, pagination: p } = response;
                const processed = results
                    .filter(u => u._id != Storage.get("userData")?.id)
                    .map(u => ({
                        ...u,
                        isPerformance: u.isPerformance !== undefined ? u.isPerformance : true
                    }));
                setData(processed);
                setPagination({ current: p.currentPage, pageSize: p.pageSize, total: p.totalItems });
            }
        } catch (err) {
            console.error("fetchData error", err);
            message.error("Failed to fetch users");
        } finally {
            setLoading(false);
        }
    };

    // Fetch user status history (admin only)
    const fetchUserStatusHistory = async (userId, page = 1, startDate = null, endDate = null) => {
        if (!isAdmin) {
            message.error("You don't have permission to view status history");
            return;
        }

        setHistoryLoading(true);
        try {
            const params = {
                page,
                limit: 10,
                sortOrder: 'desc'
            };

            // Add date filters if provided
            if (startDate) {
                const start = new Date(startDate);
                if (!isNaN(start.getTime())) {
                    params.startDate = start.toISOString();
                }
            }

            if (endDate) {
                const end = new Date(endDate);
                if (!isNaN(end.getTime())) {
                    params.endDate = end.toISOString();
                }
            }

            console.log('Fetching history with params:', params);

            const response = await API.getUserStatusHistory(userId, params);

            console.log('API Response:', response);

            // Handle different response structures
            if (response) {
                if (response.status === true && response.data) {
                    const historyData = response.data.history || [];
                    const paginationData = response.data.pagination || {};
                    const statisticsData = response.data.statistics || null;

                    if (page === 1) {
                        setUserStatusHistory(historyData);
                    } else {
                        setUserStatusHistory(prev => [...prev, ...historyData]);
                    }

                    setHistoryTotal(paginationData.total || 0);
                    setStatusStats(statisticsData);
                    setHistoryPage(page);

                    if (historyData.length === 0 && page === 1) {
                        message.info('No status history found for this user');
                    }
                } else if (response.success === true && response.data) {
                    const historyData = response.data.history || [];
                    const paginationData = response.data.pagination || {};
                    const statisticsData = response.data.statistics || null;

                    if (page === 1) {
                        setUserStatusHistory(historyData);
                    } else {
                        setUserStatusHistory(prev => [...prev, ...historyData]);
                    }

                    setHistoryTotal(paginationData.total || 0);
                    setStatusStats(statisticsData);
                    setHistoryPage(page);
                } else if (response.history) {
                    const historyData = response.history || [];
                    const paginationData = response.pagination || {};
                    const statisticsData = response.statistics || null;

                    if (page === 1) {
                        setUserStatusHistory(historyData);
                    } else {
                        setUserStatusHistory(prev => [...prev, ...historyData]);
                    }

                    setHistoryTotal(paginationData.total || 0);
                    setStatusStats(statisticsData);
                    setHistoryPage(page);
                } else if (Array.isArray(response)) {
                    if (page === 1) {
                        setUserStatusHistory(response);
                    } else {
                        setUserStatusHistory(prev => [...prev, ...response]);
                    }
                    setHistoryTotal(response.length);
                    setHistoryPage(page);
                } else {
                    console.error('Unexpected response structure:', response);
                    if (page === 1) {
                        setUserStatusHistory([]);
                        setStatusStats(null);
                    }
                    setHistoryTotal(0);
                }
            } else {
                console.error('Empty response');
                if (page === 1) {
                    setUserStatusHistory([]);
                    setStatusStats(null);
                }
                setHistoryTotal(0);
            }
        } catch (error) {
            console.error("Error fetching status history:", error);
            if (page === 1) {
                setUserStatusHistory([]);
                setStatusStats(null);
            }
            setHistoryTotal(0);
        } finally {
            setHistoryLoading(false);
        }
    };

    // Load more history (admin only)
    const loadMoreHistory = () => {
        if (!isAdmin) return;
        if (currentUser && userStatusHistory.length < historyTotal) {
            const startDate = dateRange ? dateRange[0] : null;
            const endDate = dateRange ? dateRange[1] : null;
            fetchUserStatusHistory(
                currentUser._id,
                historyPage + 1,
                startDate,
                endDate
            );
        }
    };

    // Handle date range change (admin only)
    const handleDateRangeChange = (dates) => {
        if (!isAdmin) return;
        setDateRange(dates);
        setSelectedPreset('custom');
        if (currentUser && dates) {
            fetchUserStatusHistory(currentUser._id, 1, dates[0], dates[1]);
        }
    };

    // Handle preset selection (admin only)
    const handlePresetSelect = (preset) => {
        if (!isAdmin) return;
        setSelectedPreset(preset);
        const [start, end] = getDefaultDateRange(preset);
        setDateRange([start, end]);
        if (currentUser) {
            fetchUserStatusHistory(currentUser._id, 1, start.toDate(), end.toDate());
        }
    };

    // Clear date filter (admin only)
    const clearDateFilter = () => {
        if (!isAdmin) return;
        setSelectedPreset('today');
        const [start, end] = getDefaultDateRange('today');
        setDateRange([start, end]);
        if (currentUser) {
            fetchUserStatusHistory(currentUser._id, 1, start.toDate(), end.toDate());
        }
    };

    // Debounced search
    useEffect(() => {
        if (searchDebounceRef.current) clearTimeout(searchDebounceRef.current);
        searchDebounceRef.current = setTimeout(() => fetchData(1, pagination.pageSize, searchText), 450);
        return () => clearTimeout(searchDebounceRef.current);
    }, [searchText]);

    // Handle view user
    const handleViewUser = (user) => {
        setCurrentUser(user);
        setDrawerVisible(true);
        setActiveDrawerTab('details');
        setUserStatusHistory([]);
        setHistoryPage(1);
        if (isAdmin) {
            setSelectedPreset('today');
            const [start, end] = getDefaultDateRange('today');
            setDateRange([start, end]);
        }
    };

    // Handle view status history (admin only)
    const handleViewStatusHistory = (user) => {
        if (!isAdmin) {
            message.error("You don't have permission to view status history");
            return;
        }
        setCurrentUser(user);
        setDrawerVisible(true);
        setActiveDrawerTab('history');
        setUserStatusHistory([]);
        setHistoryPage(1);
        setSelectedPreset('today');
        const [start, end] = getDefaultDateRange('today');
        setDateRange([start, end]);
        fetchUserStatusHistory(user._id, 1, start.toDate(), end.toDate());
    };

    // Toggle status (admin only) - FIXED VERSION
    const handleToggleStatus = async (record) => {
        if (!isAdmin) {
            message.error("Only admins can change status");
            return;
        }

        setCurrentToggleId(record._id);

        Modal.confirm({
            title: `Set ${record.userName} ${record.isActive ? 'Offline' : 'Online'}`,
            content: (
                <div style={{ marginTop: 16 }}>
                    <Input.TextArea
                        placeholder="Enter reason for status change (optional)"
                        rows={3}
                        id="status-change-reason"
                    />
                </div>
            ),
            onOk: async () => {
                const reasonInput = document.getElementById('status-change-reason')?.value;
                try {
                    // CRITICAL FIX: Ensure we're sending a proper boolean value
                    const newStatus = !record.isActive;
                    
                    // Create payload with explicit boolean conversion
                    const statusPayload = {
                        isActive: newStatus === true // Explicitly convert to boolean
                    };
                    
                    // Add reason if provided (as string)
                    if (reasonInput && reasonInput.trim()) {
                        statusPayload.reason = reasonInput.trim();
                    }
                    
                    console.log('Sending status update:', statusPayload); // Debug log
                    
                    const res = await API.ToggleStatus(record._id, statusPayload?.isActive);

                    if (res.success) {
                        // Update local state immediately for better UX
                        setData(prev => prev.map(u => 
                            u._id === record._id ? { ...u, isActive: newStatus } : u
                        ));

                        if (!newStatus && res.data?.sessionDuration) {
                            message.success(`Agent offline. Session duration: ${formatDuration(res.data.sessionDuration)}`);
                        } else {
                            message.success(`Agent ${newStatus ? 'online' : 'offline'} successfully`);
                        }

                        // Emit socket event if connected
                        if (socket && isSocketConnected) {
                            socket.emit("statusChanged", {
                                userId: record._id,
                                isActive: newStatus,
                                reason: reasonInput?.trim() || null,
                                timestamp: new Date().toISOString()
                            });
                        }

                        // Refresh data to ensure consistency
                        await fetchData(pagination.current, pagination.pageSize, searchText);
                    } else {
                        message.error(res.message || "Failed to update status");
                    }
                } catch (err) {
                    console.error("Status toggle error:", err);
                    message.error(err.response?.data?.message || "Failed to update status");
                } finally {
                    setCurrentToggleId(null);
                }
            },
            onCancel: () => setCurrentToggleId(null),
        });
    };

    // Manual refresh
    const handleManualRefresh = async () => {
        setLoading(true);
        try {
            await fetchData(pagination.current, pagination.pageSize, searchText);
            message.success('Data refreshed successfully');
        } catch (error) {
            console.error('Manual refresh error:', error);
            message.error('Failed to refresh data');
        } finally {
            setLoading(false);
        }
    };

    // Filter data
    const filteredData = useMemo(() => {
        return data.filter(user => {
            if (activeTab === 'admins' && user.role !== "ADMIN") return false;
            if (activeTab === 'tier-1' && user.subRole !== "TIER-1") return false;
            if (activeTab === 'tier-2' && user.subRole !== "TIER-2") return false;
            if (activeTab === 'tier-3' && user.subRole !== "TIER-3") return false;
            if (activeTab === 'sales-agents' && user.role !== "SALES-AGENT") return false;
  if (activeTab === 'service-agents' && user.role !== "SERVICE-AGENT") return false;
            if (performanceFilter === 'performance' && !user.isPerformance) return false;
            if (performanceFilter === 'non-performance' && user.isPerformance) return false;

            if (statusFilter === 'online' && !user.isActive) return false;
            if (statusFilter === 'offline' && user.isActive) return false;

            return true;
        });
    }, [data, activeTab, performanceFilter, statusFilter]);

    // Stats
    const stats = useMemo(() => {
        const total = filteredData.length;
        const agentsOnline = filteredData.filter(u => u.isActive && u.role === "SALES-AGENT").length;
        const online = filteredData.filter(u => u.isActive).length;
        const salesAgentsInPerformance = filteredData.filter(u =>
            u.role === "SALES-AGENT" && u.isPerformance
        ).length;
        const agents = filteredData.filter(u => u.role === "SALES-AGENT").length;

        return {
            total, online, agents,
            agentsOnline,
            salesAgentsInPerformance
        };
    }, [filteredData]);

    // Performance Actions Menu (admin only)
    const performanceActionsMenu = isAdmin ? (
        <Menu>
            <Menu.Item
                key="enable-all"
                icon={<FireOutlined />}
                onClick={() => handleBulkPerformanceToggle(true)}
                disabled={bulkPerformanceLoading}
            >
                Enable All Performance
            </Menu.Item>
            <Menu.Item
                key="disable-all"
                icon={<PauseOutlined />}
                onClick={() => handleBulkPerformanceToggle(false)}
                disabled={bulkPerformanceLoading}
            >
                Disable All Performance
            </Menu.Item>
        </Menu>
    ) : null;

    // Bulk Performance Toggle (admin only)
    const handleBulkPerformanceToggle = async (enable = true) => {
        if (!isAdmin) {
            message.error("Only admins can perform this action");
            return;
        }

        const salesAgents = filteredData.filter(user =>
            user.role === "SALES-AGENT" &&
            user.isPerformance !== enable
        );

        if (salesAgents.length === 0) {
            message.info(`All sales agents are already ${enable ? 'in' : 'out of'} performance mode`);
            return;
        }

        setBulkPerformanceLoading(true);
        message.loading(`${enable ? 'Enabling' : 'Disabling'} performance mode for ${salesAgents.length} agents...`, 0);

        try {
            let successCount = 0;
            let failedCount = 0;

            for (const user of salesAgents) {
                try {
                    // Ensure isPerformance is a boolean
                    const res = await API.UpdateUser(user._id, {
                        isPerformance: enable === true, // Explicit boolean
                        reason: `Bulk ${enable ? 'enable' : 'disable'} performance action`
                    });
                    if (res.success) successCount++;
                    else failedCount++;
                } catch (err) {
                    console.warn(`Failed to update user ${user._id}:`, err);
                    failedCount++;
                }
            }

            await fetchData(pagination.current, pagination.pageSize, searchText);
            message.success(
                `${enable ? 'Enabled' : 'Disabled'} performance mode for ${successCount} agent${successCount !== 1 ? 's' : ''}` +
                (failedCount > 0 ? ` (${failedCount} failed)` : "")
            );

        } catch (err) {
            console.error("Bulk performance toggle failed:", err);
            message.error("Operation failed unexpectedly");
        } finally {
            setBulkPerformanceLoading(false);
            message.destroy();
        }
    };

    // Notification Menu (admin only)
    const notificationMenu = isAdmin ? (
        <Menu style={{ width: 420, maxHeight: 500, overflowY: 'auto', padding: '8px 0' }}>
            {notifications.length === 0 ? (
                <Menu.Item disabled>
                    <Empty description="No notifications" image={Empty.PRESENTED_IMAGE_SIMPLE} />
                </Menu.Item>
            ) : (
                notifications.map((notif) => (
                    <Menu.Item key={notif.id} style={{
                        height: 'auto',
                        padding: '12px 16px',
                        background: notif.read ? 'transparent' : '#e6f7ff',
                        borderBottom: '1px solid #f0f0f0',
                    }}>
                        <div style={{ display: 'flex', gap: 12 }}>
                            <div style={{
                                width: 40,
                                height: 40,
                                borderRadius: '50%',
                                background: notif.type === 'status'
                                    ? (notif.isActive ? '#52c41a' : '#f5222d')
                                    : (notif.isPerformance ? '#f5576c' : '#fa8c16'),
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                            }}>
                                {notif.type === 'status' ? (
                                    notif.isActive ? <CheckOutlined style={{ color: '#fff' }} /> : <CloseOutlined style={{ color: '#fff' }} />
                                ) : (
                                    notif.isPerformance ? <FireOutlined style={{ color: '#fff' }} /> : <PauseOutlined style={{ color: '#fff' }} />
                                )}
                            </div>
                            <div style={{ flex: 1 }}>
                                <Text strong>{notif.userName}</Text>
                                <Text style={{ fontSize: 13, display: 'block' }}>
                                    {notif.type === 'status'
                                        ? `changed from ${notif.previousStatus ? 'Online' : 'Offline'} to ${notif.isActive ? 'Online' : 'Offline'}`
                                        : `${notif.isPerformance ? 'Performance ON' : 'Performance OFF'}`
                                    }
                                </Text>
                                <div className="notification-time">
                                    <ClockCircleOutlined />
                                    <span>{formatNotificationTime(notif.timestamp)}</span>
                                </div>
                            </div>
                        </div>
                    </Menu.Item>
                ))
            )}
        </Menu>
    ) : null;

    // Change password (admin only for others)
    const handleChangePassword = async (user) => {
        if (!user) return;
        // Allow users to change their own password, admins can change anyone's
        if (!isAdmin && user._id !== loginAgent.id) {
            message.error("You can only change your own password");
            return;
        }
        try {
            const params = { userName: user.userName };
            const resp = await API.ChangePassword(params);
            if (resp?.status) message.success(resp.message || "Password changed - check email");
            else message.error(resp?.message || "Failed to change password");
        } catch (err) {
            console.error(err);
            message.error("Failed to change password");
        }
    };
    const handleClearSelection = () => {
        setSelectedRowKeys([]);
    };
    // Delete selected (admin only)
    const deleteSelected = async () => {
        if (!isAdmin) {
            message.error("Only admins can delete users");
            return;
        }
        if (!selectedRowKeys.length) return message.warning("No rows selected");
        try {
            const res = await API.DeleteUserSoft(selectedRowKeys);
            if (res.status) {
                message.success("Deleted selected records");
                setSelectedRowKeys([]);
                fetchData(pagination.current, pagination.pageSize, searchText);
            } else {
                message.error(res.message || "Failed to delete");
            }
        } catch (err) {
            console.error(err);
            message.error("Failed to delete selected records");
        }
    };

    // Get role badge class
    const getRoleBadgeClass = (role, subRole) => {
        if (role === "ADMIN") return "role-badge admin";
        if (role === "SALES-AGENT") {
            if (subRole === "TIER-1") return "role-badge tier-1";
            if (subRole === "TIER-2") return "role-badge tier-2";
            if (subRole === "TIER-3") return "role-badge tier-3";
            return "role-badge sales-agent";
        }
        return "";
    };

    const renderGroupToggle = (record, group) => {
        // A group only applies to sales agents on its own tier.
        if (record?.role !== "SALES-AGENT" || record?.subRole !== group.tier) {
            return <Text type="secondary">N/A</Text>;
        }

        const loadingKey = `${record._id}-${group._id}`;
        const isEditable = isAdmin || record._id === loginAgent.id;
        const checked = (record?.domainGroups || []).map(String).includes(String(group._id));

        return (
            <Switch
                checked={checked}
                disabled={!isEditable}
                loading={groupToggling[loadingKey]}
                onChange={(nextChecked) => handleGroupToggle(record, group, nextChecked)}
                checkedChildren="ON"
                unCheckedChildren="OFF"
                style={{
                    background: checked ? "#52c41a" : "#bfbfbf",
                    borderColor: checked ? "#52c41a" : "#bfbfbf",
                    opacity: isEditable ? 1 : 0.7
                }}
            />
        );
    };

    // Table columns with role-based visibility
  // Table columns with edit button
const columns = [
    {
        title: "Agent",
        key: "user",
        fixed: "left",
        width: 340,
        render: (_, record) => {
            const initials = (record.userName || "U")[0]?.toUpperCase();
            const gradient = getAvatarGradient(record.userName || record.email || "");

            return (
                <div style={{ display: "flex", gap: 16, alignItems: "center" }}>
                    <div style={{ position: 'relative' }}>
                        <div
                            style={{
                                width: 56,
                                height: 56,
                                borderRadius: '50%',
                                background: record.isPerformance ? "#f093fb" : gradient,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                color: '#fff',
                                fontSize: 22,
                                fontWeight: 800,
                                border: '3px solid #fff',
                                cursor: 'pointer',
                                boxShadow: record.isActive ? '0 0 20px #52c41a' : 'none',
                                transition: 'all 0.3s ease',
                            }}
                            className="action-button"
                            onClick={() => handleViewUser(record)}
                        >
                            {initials}
                        </div>
                        {record.isPerformance && (
                            <div className="floating-badge" style={{
                                position: 'absolute',
                                bottom: -4,
                                right: -4,
                                background: '#fa709a',
                                borderRadius: '50%',
                                width: 28,
                                height: 28,
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '3px solid #fff',
                            }}>
                                <FireOutlined style={{ fontSize: 14, color: '#fff' }} />
                            </div>
                        )}
                    </div>

                    <div style={{ flex: 1 }}>
                        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                            <Text strong style={{ fontSize: 16, cursor: 'pointer' }} onClick={() => handleViewUser(record)}>
                                {record.userName}
                            </Text>
                            <div className={record.isActive ? 'online-dot' : 'offline-dot'} />
                        </div>
                        <Text type="secondary" style={{ fontSize: 13 }}>
                            {record.firstName} {record.lastName}
                        </Text>
                        {record.lastSeenAt && !record.isActive && (
                            <div style={{ fontSize: 11, color: '#999', marginTop: 2 }}>
                                Last seen: {formatNotificationTime(record.lastSeenAt)}
                            </div>
                        )}
                    </div>
                </div>
            );
        },
    },
    {
        title: "Extension",
        key: "extension",
        width: 120,
        render: (_, record) => (
            <Tag color="purple" style={{ fontSize: 14, padding: '4px 12px', borderRadius: 20 }}>
                {record.extension || "—"}
            </Tag>
        ),
    },
    {
        title: "Role",
        key: "role",
        width: 150,
        render: (_, record) => (
            <div>
                <div className={getRoleBadgeClass(record.role, record.subRole)}>
                    {record.role}
                    {isAdmin && record.subRole && ` | ${record.subRole}`}
                </div>
                {/* Owner account: switch to turn super admin on/off for ADMIN users */}
                {canManageSuperAdmin && record.role === "ADMIN" && (
                    <div style={{ marginTop: 6, display: 'flex', alignItems: 'center', gap: 6 }}>
                        <Popconfirm
                            title={record.isSuperAdmin === true
                                ? `Remove super admin from ${record.userName || record.firstName || 'this user'}?`
                                : `Make ${record.userName || record.firstName || 'this user'} super admin?`}
                            okText="Yes"
                            cancelText="No"
                            onConfirm={() => handleSuperAdminToggle(record, record.isSuperAdmin !== true)}
                        >
                            <Switch
                                size="small"
                                checked={record.isSuperAdmin === true}
                                loading={superAdminToggling[record._id] === true}
                                checkedChildren={<CrownOutlined />}
                            />
                        </Popconfirm>
                        <span style={{ fontSize: 11, color: record.isSuperAdmin === true ? '#d48806' : '#999', fontWeight: 600 }}>
                            Super Admin
                        </span>
                    </div>
                )}
                {/* Everyone else: display only */}
                {!canManageSuperAdmin && record.role === "ADMIN" && record.isSuperAdmin === true && (
                    <div style={{ fontSize: 11, marginTop: 4, color: '#d48806', fontWeight: 600 }}>
                        <CrownOutlined /> Super Admin
                    </div>
                )}
                {record.totalOnlineTime > 0 && (
                    <div style={{ fontSize: 11, marginTop: 4, color: '#666' }}>
                        <ClockCircleOutlined /> {formatDuration(record.totalOnlineTime)}
                    </div>
                )}
            </div>
        ),
    },
    {
        title: "Status",
        key: "status",
        width: 100,
        render: (_, record) => (
            <Tag color={record.isActive ? 'success' : 'default'} style={{ borderRadius: 20 }}>
                {record.isActive ? 'Online' : 'Offline'}
            </Tag>
        ),
    },
    // One column per visible domain group, of every tier, generated from what an
    // admin has configured. Adding, renaming, reordering or hiding a group
    // changes these columns with no code change. A switch only appears on the
    // rows of that group's own tier; the rest read N/A.
    ...visibleGroups.map(group => ({
        // Each tier has its own "Default", so a name shared across tiers is
        // qualified. A name unique across all groups is shown as the admin typed it.
        title: visibleGroups.filter(other => other.name === group.name).length > 1
            ? `${group.name} (${group.tier})`
            : group.name,
        key: `domain-group-${group._id}`,
        width: 110,
        render: (_, record) => renderGroupToggle(record, group),
    })),
    // Performance column - only visible to admins
    ...(isAdmin ? [{
        title: "Lead Reception",
        key: "performance",
        width: 150,
        render: (_, record) => {
            if (record.role !== "SALES-AGENT") return <Text type="secondary">N/A</Text>;

            return (
                <Switch
                    checked={record.isPerformance === true}
                    onChange={() => handlePerformanceToggle(record._id, record.isPerformance)}
                    loading={performanceToggling[record._id]}
                    checkedChildren={<FireOutlined />}
                    unCheckedChildren={<PauseOutlined />}
                    style={{
                        background: record.isPerformance ? '#f093fb' : '#2c3e50',
                    }}
                />
            );
        },
    }] : []),
    {
        title: "Actions",
        key: "actions",
        width: 200,
        fixed: 'right',
        render: (_, record) => (
            <Space>
                <Tooltip title="View Details">
                    <Button
                        icon={<EyeOutlined />}
                        size="small"
                        className="action-button"
                        style={{ background: '#764ba2', color: '#fff', border: 'none' }}
                        onClick={() => handleViewUser(record)}
                    />
                </Tooltip>

                {/* Edit Button - Always visible to admins, users can edit themselves */}
                {(isAdmin || record._id === loginAgent.id) && (
                    <Tooltip title="Edit User">
                        <Button
                            icon={<EditOutlined />}
                            size="small"
                            className="action-button"
                            style={{ background: '#11998e', color: '#fff', border: 'none' }}
                            onClick={() => handleEditUser(record)}
                        />
                    </Tooltip>
                )}

                {/* Status History button - only visible to admins */}
                {isAdmin && (
                    <Tooltip title="Status History">
                        <Button
                            icon={<HistoryOutlined />}
                            size="small"
                            className="action-button"
                            style={{ background: '#fa709a', color: '#fff', border: 'none' }}
                            onClick={() => handleViewStatusHistory(record)}
                        />
                    </Tooltip>
                )}

                {/* Dropdown menu - different options based on role */}
                <Dropdown
                    menu={{
                        items: [
                            // Change password - available to all for their own, admins for all
                            {
                                key: 'change-password',
                                label: 'Change Password',
                                icon: <KeyOutlined />,
                                onClick: () => handleChangePassword(record)
                            },
                            // Toggle status - only admins
                            ...(isAdmin ? [{
                                key: 'toggle-status',
                                label: record.isActive ? 'Set Offline' : 'Set Online',
                                icon: record.isActive ? <PoweroffOutlined /> : <CheckCircleOutlined />,
                                onClick: () => handleToggleStatus(record)
                            }] : [])
                        ]
                    }}
                >
                    <Button icon={<EllipsisOutlined />} size="small" className="action-button" />
                </Dropdown>
            </Space>
        ),
    },
];

    // Service Status Component - simplified for non-admins
    const ServiceStatusIndicator = () => (
        <div className="gradient-card" style={{ marginBottom: 24, padding: 16 }}>
            <Row align="middle" justify="space-between">
                <Col>
                    <Space>
                        <div style={{
                            width: 12,
                            height: 12,
                            borderRadius: '50%',
                            background: isSocketConnected ? '#38ef7d' : '#e74c3c',
                            animation: isSocketConnected ? 'pulse 1.5s ease-in-out infinite' : 'none'
                        }} />
                        <Text style={{ color: '#fff' }}>
                            System: {isSocketConnected ? 'Connected' : 'Disconnected'}
                        </Text>
                        <ClockCircleOutlined style={{ color: '#fff' }} />
                        <Text style={{ color: '#fff' }}>
                            {new Date().toLocaleTimeString()}
                        </Text>
                    </Space>
                </Col>
                <Col>
                    <Space>
                        {/* Notifications only for admins */}
                        {isAdmin && (
                            <Dropdown overlay={notificationMenu} trigger={['click']}>
                                <Badge count={notificationCount} size="small">
                                    <Button
                                        icon={<BellFilled />}
                                        className={notificationCount > 0 ? 'notification-bell' : ''}
                                        style={{ background: '#fff' }}
                                    />
                                </Badge>
                            </Dropdown>
                        )}
                        <Button icon={<ReloadOutlined />} onClick={handleManualRefresh} loading={loading} style={{ background: '#fff' }}>
                            Refresh
                        </Button>
                    </Space>
                </Col>
            </Row>
        </div>
    );

    return (
        <div style={{
            minHeight: "100vh",
            padding: 28,
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}>
            {/* Header */}
            <div style={{ marginBottom: 28 }}>
                <Row justify="space-between" align="middle">
                    <Col>
                        <Title level={1} style={{ color: '#fff', margin: 0, fontWeight: 800 }}>
                            Team Management
                        </Title>
                        <Text style={{ color: 'rgba(255,255,255,0.9)', fontSize: 16 }}>
                            {isAdmin ? 'Manage agents, track online/offline history, and control lead distribution' : 'View team members and their status'}
                        </Text>
                    </Col>
                    <Col>
                        <Space>
                            <Search
                                placeholder="Search agents..."
                                value={searchText}
                                onChange={(e) => setSearchText(e.target.value)}
                                style={{ width: 300 }}
                                size="large"
                            />
                            {isAdmin && (
 <>  <Button 
                icon={<DeleteOutlined />} 
                onClick={() => setRecycleBinVisible(true)}
                size="large"
            >
                Recycle Bin
            </Button>
                                    {/* Delete button appears when records are selected */}
                                    {selectedRowKeys.length > 0 && (
                                        <Popconfirm
                                            title={`Delete ${selectedRowKeys.length} selected user${selectedRowKeys.length > 1 ? 's' : ''}?`}
                                            description="This action can be undone from the recycle bin."
                                            onConfirm={deleteSelected}
                                            okText="Yes"
                                            cancelText="No"
                                            okButtonProps={{ danger: true }}
                                        >
                                            <Button 
                                                danger 
                                                icon={<DeleteOutlined />} 
                                                size="large"
                                            >
                                                Delete ({selectedRowKeys.length})
                                            </Button>
                                        </Popconfirm>
                                    )}
                                    <AddTeam refreshTeamList={() => fetchData(1, pagination.pageSize, searchText)} />
                                </>                            )}
                        </Space>
                    </Col>
                </Row>
                <ServiceStatusIndicator />
            </div>

            {/* Stats Cards - slightly different for non-admins */}
            <Row gutter={[20, 20]} style={{ marginBottom: 24 }}>
                <Col xs={24} sm={12} md={6}>
                    <Card className="gradient-card stat-card" style={{ background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }}>
                        <Statistic
                            title={<span style={{ color: 'rgba(255,255,255,0.8)' }}>Total Agents</span>}
                            value={stats.agents}
                            prefix={<TeamOutlined />}
                            valueStyle={{ color: '#fff', fontSize: 32 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card className="gradient-card stat-card" style={{ background: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)' }}>
                        <Statistic
                            title={<span style={{ color: 'rgba(255,255,255,0.8)' }}>Online Now</span>}
                            value={stats.agentsOnline}
                            suffix={`/ ${stats.agents}`}
                            prefix={<CheckCircleOutlined />}
                            valueStyle={{ color: '#fff', fontSize: 32 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card className="gradient-card stat-card performance-active">
                        <Statistic
                            title={<span style={{ color: 'rgba(255,255,255,0.8)' }}>Receiving Leads</span>}
                            value={stats.salesAgentsInPerformance}
                            suffix={`/ ${stats.agents}`}
                            prefix={<FireOutlined />}
                            valueStyle={{ color: '#fff', fontSize: 32 }}
                        />
                    </Card>
                </Col>
                <Col xs={24} sm={12} md={6}>
                    <Card className="gradient-card stat-card" style={{ background: 'linear-gradient(135deg, #fa709a 0%, #fee140 100%)' }}>
                        <Statistic
                            title={<span style={{ color: 'rgba(255,255,255,0.8)' }}>Total Users</span>}
                            value={stats.total}
                            prefix={<UserOutlined />}
                            valueStyle={{ color: '#fff', fontSize: 32 }}
                        />
                    </Card>
                </Col>
            </Row>

            {/* Main Table */}
            <Card className="glass-card" style={{ borderRadius: 20, overflow: 'hidden' }}>
                <Tabs activeKey={activeTab} onChange={setActiveTab} type="card" size="large">
                    <TabPane tab={<span><TeamOutlined /> All Users <Badge count={data.length} style={{ background: '#667eea' }} /></span>} key="all" />
                    <TabPane tab={<span><CrownOutlined /> Admins <Badge count={data.filter(u => u.role === "ADMIN").length} style={{ background: '#f093fb' }} /></span>} key="admins" />
                    <TabPane tab={<span><RocketOutlined /> Sales Agents <Badge count={data.filter(u => u.role === "SALES-AGENT").length} style={{ background: '#4facfe' }} /></span>} key="sales-agents" />
                    <TabPane tab={<span><RocketOutlined /> Service Agents <Badge count={data.filter(u => u.role === "SERVICE-AGENT").length} style={{ background: '#4facfe' }} /></span>} key="service-agents" />

                    {/* Tier tabs only visible to admins */}
                    {isAdmin && (
                        <>
                            <TabPane tab={<span>Tier 1 <Badge count={data.filter(u => u.subRole === "TIER-1").length} style={{ background: '#11998e' }} /></span>} key="tier-1" />
                            <TabPane tab={<span>Tier 2 <Badge count={data.filter(u => u.subRole === "TIER-2").length} style={{ background: '#fa709a' }} /></span>} key="tier-2" />
                            <TabPane tab={<span>Tier 3 <Badge count={data.filter(u => u.subRole === "TIER-3").length} style={{ background: '#f5576c' }} /></span>} key="tier-3" />
                        </>
                    )}
                </Tabs>

                {/* Filters - simplified for non-admins */}
                <Row gutter={16} style={{ padding: '16px 24px', background: '#f5f7fa' }}>
                    <Col span={isAdmin ? 6 : 8}>
                        <Select
                            value={performanceFilter}
                            onChange={setPerformanceFilter}
                            style={{ width: '100%' }}
                            size="large"
                            disabled={!isAdmin} // Disable for non-admins
                        >
                            <Option value="all">All Lead Reception</Option>
                            <Option value="performance">🔥 Active</Option>
                            <Option value="non-performance">⏸️ Paused</Option>
                        </Select>
                    </Col>
                    <Col span={isAdmin ? 6 : 8}>
                        <Select
                            value={statusFilter}
                            onChange={setStatusFilter}
                            style={{ width: '100%' }}
                            size="large"
                        >
                            <Option value="all">All Status</Option>
                            <Option value="online">Online</Option>
                            <Option value="offline">Offline</Option>
                        </Select>
                    </Col>
                    <Col span={isAdmin ? 12 : 8}>
                        <Space>
                            {/* Bulk actions only for admins */}
                            {isAdmin && activeTab === 'sales-agents' && (
                                <>
                                    <Dropdown overlay={performanceActionsMenu}>
                                        <Button icon={<FireOutlined />} size="large">Bulk Actions</Button>
                                    </Dropdown>
                                    <Popconfirm 
                                        title="Set all sales agents offline?" 
                                        onConfirm={handleMakeAllOffline}
                                        okText="Yes"
                                        cancelText="No"
                                    >
                                        <Button icon={<PoweroffOutlined />} danger size="large">Set All Offline</Button>
                                    </Popconfirm>
                                </>
                            )}
                        </Space>
                    </Col>
                </Row>

                {/* Table */}
                <div style={{ padding: 24 }}>
                    <Table
                        columns={columns}
                        dataSource={filteredData}
                        loading={loading}
                        rowSelection={isAdmin ? { selectedRowKeys, onChange: setSelectedRowKeys } : undefined}
                        onChange={(p) => fetchData(p.current, p.pageSize, searchText)}
                        rowKey="_id"
                        pagination={{
                            current: pagination.current,
                            pageSize: pagination.pageSize,
                            total: pagination.total,
                            showSizeChanger: true,
                            showTotal: (total) => `Total ${total} users`,
                        }}
                        scroll={{ x: 1200 }}
                        rowClassName={(record) => {
                            if (record.isPerformance) return 'table-row-active';
                            return record.isActive ? 'table-row-online' : 'table-row-offline';
                        }}
                    />
                </div>
            </Card>

            {/* Enhanced Drawer with Tabs - different for admins vs non-admins */}
            <Drawer
                title={null}
                placement="right"
                width={drawerWidth}
                closable={false}
                open={drawerVisible}
                onClose={() => setDrawerVisible(false)}
                styles={{ body: { padding: 0 } }}
                extra={
                    <Button type="text" icon={<CloseIcon />} onClick={() => setDrawerVisible(false)} />
                }
            >
                {currentUser && (
                    <>
                        {/* Drawer Header */}
                        <div className={`drawer-header ${currentUser.isPerformance ? 'performance-active' : ''}`}>
                            <div style={{ position: 'relative', display: 'inline-block' }}>
                                <Avatar
                                    size={80}
                                    style={{
                                        background: 'rgba(255,255,255,0.2)',
                                        fontSize: 36,
                                        border: '4px solid rgba(255,255,255,0.3)',
                                    }}
                                >
                                    {(currentUser.userName || "U")[0]?.toUpperCase()}
                                </Avatar>
                                {currentUser.isPerformance && (
                                    <div className="floating-badge" style={{
                                        position: 'absolute',
                                        bottom: 0,
                                        right: 0,
                                        background: '#fa709a',
                                        borderRadius: '50%',
                                        width: 30,
                                        height: 30,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        border: '3px solid #fff',
                                    }}>
                                        <FireOutlined />
                                    </div>
                                )}
                            </div>
                            <Title level={3} style={{ color: '#fff', margin: '16px 0 4px' }}>
                                {currentUser.userName}
                            </Title>
                            <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                                {currentUser.firstName} {currentUser.lastName}
                            </Text>
                            <div style={{ marginTop: 8 }}>
                                <span className={getRoleBadgeClass(currentUser.role, currentUser.subRole)}>
                                    {currentUser.role} {currentUser.subRole && `| ${currentUser.subRole}`}
                                </span>
                                {currentUser.role === "ADMIN" && currentUser.isSuperAdmin === true && (
                                    <Tag color="gold" icon={<CrownOutlined />} style={{ marginLeft: 8, borderRadius: 20 }}>
                                        Super Admin
                                    </Tag>
                                )}
                            </div>
                            {currentUser.totalOnlineTime > 0 && (
                                <Tag color="rgba(255,255,255,0.2)" style={{ color: '#fff', marginTop: 8, borderRadius: 20 }}>
                                    <ClockCircleOutlined /> Total Online: {formatDuration(currentUser.totalOnlineTime)}
                                </Tag>
                            )}
                        </div>

                        {/* Tabs - only show history tab for admins */}
                        <Tabs
                            activeKey={activeDrawerTab}
                            onChange={setActiveDrawerTab}
                            className="drawer-tabs"
                            items={[
                                {
                                    key: 'details',
                                    label: 'Details',
                                    children: (
                                        <div style={{ padding: 24 }}>
                                            {/* Performance Mode Card - only for sales agents and admins can see controls */}
                                            {currentUser.role === "SALES-AGENT" && (
                                                <Card
                                                    className="stat-card"
                                                    style={{
                                                        marginBottom: 24,
                                                        background: currentUser.isPerformance
                                                            ? 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)'
                                                            : 'linear-gradient(135deg, #606c88 0%, #3f4c6b 100%)',
                                                        border: 'none',
                                                        borderRadius: 16,
                                                    }}
                                                >
                                                    <Text strong style={{ color: '#fff', fontSize: 16, display: 'block' }}>
                                                        {currentUser.isPerformance ? '🔥 Performance ACTIVE' : '⏸️ Performance PAUSED'}
                                                    </Text>
                                                    <Text style={{ color: 'rgba(255,255,255,0.9)' }}>
                                                        {currentUser.isPerformance
                                                            ? "Receiving new leads automatically"
                                                            : "Not receiving new leads"}
                                                    </Text>
                                                    {/* Only admins can toggle performance */}
                                                    {isAdmin && (
                                                        <Button
                                                            block
                                                            style={{ marginTop: 16, background: '#fff', border: 'none', fontWeight: 600 }}
                                                            onClick={() => handlePerformanceToggle(currentUser._id, currentUser.isPerformance)}
                                                            loading={performanceToggling[currentUser._id]}
                                                        >
                                                            {currentUser.isPerformance ? "Pause" : "Enable"} Lead Reception
                                                        </Button>
                                                    )}
                                                </Card>
                                            )}

                                            {/* Contact Info */}
                                            <Card
                                                title={<span><UserOutlined /> Contact Information</span>}
                                                size="small"
                                                style={{ marginBottom: 16, borderRadius: 16 }}
                                                className="stat-card"
                                            >
                                                <Descriptions column={1}>
                                                    <Descriptions.Item label="Email">{currentUser.email}</Descriptions.Item>
                                                    <Descriptions.Item label="Extension">{currentUser.extension}</Descriptions.Item>
                                                    <Descriptions.Item label="Role">{currentUser.role}</Descriptions.Item>
                                                    {currentUser.subRole && (
                                                        <Descriptions.Item label="Sub Role">{currentUser.subRole}</Descriptions.Item>
                                                    )}
                                                    {currentUser.role === "SALES-AGENT" && (
                                                        <Descriptions.Item label="Domain Groups">
                                                            {agentGroupNames(currentUser, groups).join(", ") || "None"}
                                                        </Descriptions.Item>
                                                    )}
                                                </Descriptions>
                                            </Card>

                                            {/* Status Info */}
                                            <Card
                                                title={<span><ClockCircleOutlined /> Status Information</span>}
                                                size="small"
                                                style={{ marginBottom: 16, borderRadius: 16 }}
                                                className="stat-card"
                                            >
                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                    <div>
                                                        <Tag color={currentUser.isActive ? 'success' : 'default'} style={{ padding: '4px 12px', borderRadius: 20 }}>
                                                            {currentUser.isActive ? 'Online' : 'Offline'}
                                                        </Tag>
                                                        {currentUser.lastSeenAt && !currentUser.isActive && (
                                                            <div style={{ fontSize: 12, color: '#999', marginTop: 8 }}>
                                                                Last seen: {new Date(currentUser.lastSeenAt).toLocaleString()}
                                                            </div>
                                                        )}
                                                    </div>
                                                    {/* Only admins can toggle status for sales agents */}
                                                    {isAdmin && currentUser.role === "SALES-AGENT" && (
                                                        <Button
                                                            onClick={() => handleToggleStatus(currentUser)}
                                                            loading={currentToggleId === currentUser._id}
                                                            danger={currentUser.isActive}
                                                            style={{ borderRadius: 20 }}
                                                        >
                                                            {currentUser.isActive ? "Set Offline" : "Set Online"}
                                                        </Button>
                                                    )}
                                                </div>
                                                {currentUser.currentSessionStartedAt && currentUser.isActive && (
                                                    <Alert
                                                        message={`Session started: ${new Date(currentUser.currentSessionStartedAt).toLocaleString()}`}
                                                        type="success"
                                                        showIcon
                                                        style={{ marginTop: 16, borderRadius: 12 }}
                                                    />
                                                )}
                                            </Card>

                                            {/* Actions - different for admins vs non-admins */}
                                            <Button
                                                icon={<KeyOutlined />}
                                                onClick={() => handleChangePassword(currentUser)}
                                                block
                                                style={{
                                                    borderRadius: 20,
                                                    height: 45,
                                                    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                                                    border: 'none',
                                                    color: '#fff',
                                                    fontWeight: 600
                                                }}
                                                className="action-button"
                                            >
                                                Change Password
                                            </Button>
                                        </div>
                                    ),
                                },
                                // History tab - only visible to admins
                                ...(isAdmin ? [{
                                    key: 'history',
                                    label: 'Status History',
                                    children: (
                                        <div style={{ padding: 24 }}>
                                            {/* Statistics Cards */}
                                            {statusStats && (
                                                <Row gutter={16} style={{ marginBottom: 16 }}>
                                                    <Col span={8}>
                                                        <Card size="small" className="stat-card" style={{ background: '#f0f5ff', borderRadius: 16 }}>
                                                            <Statistic
                                                                title="Total Changes"
                                                                value={statusStats.totalChanges || 0}
                                                                valueStyle={{ color: '#1890ff', fontSize: 20, fontWeight: 700 }}
                                                            />
                                                        </Card>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Card size="small" className="stat-card" style={{ background: '#f6ffed', borderRadius: 16 }}>
                                                            <Statistic
                                                                title="Online"
                                                                value={statusStats.onlineCount || 0}
                                                                valueStyle={{ color: '#52c41a', fontSize: 20, fontWeight: 700 }}
                                                            />
                                                        </Card>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Card size="small" className="stat-card" style={{ background: '#fff2f0', borderRadius: 16 }}>
                                                            <Statistic
                                                                title="Offline"
                                                                value={statusStats.offlineCount || 0}
                                                                valueStyle={{ color: '#f5222d', fontSize: 20, fontWeight: 700 }}
                                                            />
                                                        </Card>
                                                    </Col>
                                                </Row>
                                            )}

                                            {/* Date Range Filter with Presets - only for admins */}
                                            <div style={{ marginBottom: 16 }}>
                                                <Space direction="vertical" style={{ width: '100%' }} size="middle">
                                                    {/* Quick Preset Buttons */}
                                                    <Space wrap>
                                                        {['today', 'yesterday', 'thisWeek', 'last7Days', 'thisMonth', 'last30Days'].map(preset => (
                                                            <Button
                                                                key={preset}
                                                                type={selectedPreset === preset ? 'primary' : 'default'}
                                                                onClick={() => handlePresetSelect(preset)}
                                                                className={`quick-filter-btn ${selectedPreset === preset ? 'active' : ''}`}
                                                                size="small"
                                                            >
                                                                {preset.replace(/([A-Z])/g, ' $1').trim()}
                                                            </Button>
                                                        ))}
                                                    </Space>

                                                    {/* Custom Range Picker */}
                                                    <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                        <RangePicker
                                                            onChange={handleDateRangeChange}
                                                            value={dateRange}
                                                            style={{ flex: 1 }}
                                                            allowClear
                                                            placeholder={['Start Date', 'End Date']}
                                                            size="middle"
                                                        />
                                                        {dateRange && selectedPreset === 'custom' && (
                                                            <Button onClick={clearDateFilter} size="middle">
                                                                Reset
                                                            </Button>
                                                        )}
                                                    </div>

                                                    {/* Active Filter Indicator */}
                                                    {dateRange && (
                                                        <Alert
                                                            message={
                                                                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                                    <span>
                                                                        <CalendarOutlined /> {dayjs(dateRange[0]).format('MM-DD-YYYY')} - {dayjs(dateRange[1]).format('MM-DD-YYYY')}
                                                                    </span>
                                                                    {selectedPreset !== 'custom' && (
                                                                        <Tag color="blue" style={{ borderRadius: 20 }}>
                                                                            {selectedPreset.replace(/([A-Z])/g, ' $1').trim()}
                                                                        </Tag>
                                                                    )}
                                                                </div>
                                                            }
                                                            type="info"
                                                            showIcon
                                                            style={{ marginTop: 8, borderRadius: 12 }}
                                                        />
                                                    )}
                                                </Space>
                                            </div>

                                            {/* Timeline */}
                                            <Card
                                                title={<span><HistoryOutlined /> Status Change Timeline</span>}
                                                size="small"
                                                extra={<Badge count={historyTotal} style={{ background: '#667eea' }} />}
                                                style={{ borderRadius: 16 }}
                                                className="stat-card"
                                            >
                                                {historyLoading && userStatusHistory.length === 0 ? (
                                                    <div style={{ textAlign: 'center', padding: 40 }}>
                                                        <Spin size="large" />
                                                        <Text style={{ display: 'block', marginTop: 16 }}>Loading history...</Text>
                                                    </div>
                                                ) : userStatusHistory.length > 0 ? (
                                                    <div className="timeline-container">
                                                        <Timeline mode="left">
                                                            {userStatusHistory.map((item, index) => (
                                                                <Timeline.Item
                                                                    key={index}
                                                                    color={item.newStatus ? '#52c41a' : '#f5222d'}
                                                                    dot={item.newStatus ? <CheckCircleFilled /> : <CloseCircleFilled />}
                                                                    label={
                                                                        <div style={{ fontSize: 11, color: '#999' }}>
                                                                            {new Date(item.timestamp).toLocaleString()}
                                                                        </div>
                                                                    }
                                                                >
                                                                    <Card size="small" className="status-change-card" style={{ borderRadius: 12 }}>
                                                                        <div style={{ display: 'flex', gap: 8, alignItems: 'center', marginBottom: 8 }}>
                                                                            <Tag color={item.newStatus ? 'green' : 'red'} style={{ borderRadius: 20 }}>
                                                                                {item.newStatus ? 'ONLINE' : 'OFFLINE'}
                                                                            </Tag>
                                                                            {item.changeSource && (
                                                                                <Tag color="blue" style={{ borderRadius: 20 }}>{item.changeSource}</Tag>
                                                                            )}
                                                                        </div>
                                                                        <Descriptions size="small" column={1}>
                                                                            {item.changedBy && (
                                                                                <Descriptions.Item label="Changed By">
                                                                                    {typeof item.changedBy === 'object'
                                                                                        ? `${item.changedBy.firstName || ''} ${item.changedBy.lastName || ''}`.trim() || 'System'
                                                                                        : 'System'}
                                                                                </Descriptions.Item>
                                                                            )}
                                                                            {item.metadata?.sessionDuration && (
                                                                                <Descriptions.Item label="Duration">
                                                                                    <Text style={{ color: '#52c41a' }}>
                                                                                        <ClockCircleOutlined /> {formatDuration(item.metadata.sessionDuration)}
                                                                                    </Text>
                                                                                </Descriptions.Item>
                                                                            )}
                                                                            {item.metadata?.reason && (
                                                                                <Descriptions.Item label="Reason">
                                                                                    {item.metadata.reason}
                                                                                </Descriptions.Item>
                                                                            )}
                                                                            {item.ipAddress && (
                                                                                <Descriptions.Item label="IP">
                                                                                    <GlobalOutlined /> {item.ipAddress}
                                                                                </Descriptions.Item>
                                                                            )}
                                                                        </Descriptions>
                                                                    </Card>
                                                                </Timeline.Item>
                                                            ))}
                                                        </Timeline>

                                                        {/* Load More */}
                                                        {userStatusHistory.length < historyTotal && (
                                                            <div style={{ textAlign: 'center', marginTop: 16 }}>
                                                                <Button
                                                                    onClick={loadMoreHistory}
                                                                    loading={historyLoading}
                                                                    icon={<ClockCircleOutlined />}
                                                                    style={{ borderRadius: 20 }}
                                                                >
                                                                    Load More ({historyTotal - userStatusHistory.length} remaining)
                                                                </Button>
                                                            </div>
                                                        )}
                                                    </div>
                                                ) : (
                                                    <Empty
                                                        description="No status history found"
                                                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                                                    />
                                                )}
                                            </Card>
                                        </div>
                                    ),
                                }] : [])
                            ]}
                        />
                    </>
                )}
            </Drawer>
<EditTeamDrawer
    visible={editDrawerVisible}
    onClose={() => {
        setEditDrawerVisible(false);
        setEditingUser(null);
    }}
    onUpdate={handleUserUpdate}
    user={editingUser}
    isAdmin={isAdmin}
/>
            {/* Recycle Bin - only for admins */}
            {isAdmin && (
                <RecycleBin
                    visible={recycleBinVisible}
                    onClose={() => setRecycleBinVisible(false)}
                    onRestoreSuccess={() => fetchData(pagination.current, pagination.pageSize, searchText)}
                />
            )}
        </div>
    );
};

export default Team; 


